import React from "react"
import tw, { styled } from "twin.macro"

import Logo from "images/logos/demand360-product.png"
import LogoLegend from "images/logos/demand360-product-legend.svg"

const Styles = styled.div`
  .logo {
    width: 250px;

    @media (min-width: 640px) {
      width: 400px;
    }

    &.main {
      height: 30px;

      @media (min-width: 640px) {
        height: 48px;
      }
    }

    &.legend {
      ${tw`mt-4 l:mt-5`}

      height: 6px;

      @media (min-width: 640px) {
        height: 9px;
      }
    }
  }

  &.demand360 {
    .logo {
      @media (min-width: 1200px) {
        width: 360px;
      }

      &.main {
        @media (min-width: 1200px) {
          height: 43px;
        }
      }

      &.legend {
        ${tw`l:mt-3`}

        @media (min-width: 1200px) {
          height: 8.1px;
        }
      }
    }
  }
`

export default function Demand360Logo({ className = "" }) {
  return (
    <Styles className={className}>
      <img className="logo main" src={Logo} />
      <img className="logo legend" src={LogoLegend} />
    </Styles>
  )
}
